var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-sm":"","text-xs-left":""}},[_c('v-layout',{class:{ 'pa-2': !_vm.isMobile() },attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('StartupList',{attrs:{"approved":1}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }